<div id="list" *ngIf="dataList.total > 0">
  <table width="100%">
    <thead *ngIf="dataList.thead">
      <tr>
        <th *ngFor="let val of dataList.thead; let i = index">
          <div *ngIf="val != 'AÇÕES'" [ngSwitch]="i">
            <div *ngSwitchCase="currencyColumn" class="currency-title">
              <span>{{ val }}</span>
            </div>
            <span *ngSwitchDefault>{{ val }}</span>
          </div>
          <div *ngIf="val == 'AÇÕES'" class="text-align-center">{{ val }}</div>
        </th>
      </tr>
    </thead>

    <tbody *ngIf="dataList.tbody">
      <ng-template ngFor let-arr let-i="index" [ngForOf]="dataList.tbody">
        <tr [class.click]="link">
          <ng-container *ngFor="let val of arr.data; let i = index">
            <td
              [class.alert]="arr.data[7] === 'Aguardando Pedido SAP'"
              *ngIf="!val?.row"
              (click)="openModal(arr.data[arr.data.length - 1].id)"
            >
              <div class="tooltip" [hidden]="i !== 4">
                <p *ngIf="arr.data[7] === 'Aguardando Pedido SAP'">
                  Clique para obter maiores detalhes
                </p>
              </div>
              <div *ngIf="!val?.actions" [ngSwitch]="i">
                <div
                  *ngSwitchCase="currencyColumn"
                  class="currency-column item"
                >
                  {{ val == "null" ? "" : (val | currencyFormat: "ptBR") }}
                </div>
                <div *ngSwitchDefault class="item">
                  {{ val == "null" ? "" : val }}
                </div>
              </div>

              <div class="text-align-center" *ngIf="val?.actions">
                <div class="btn" *ngFor="let type of val.actions">
                  <div *ngIf="type == 'view'">
                    <button
                      class="icn-view"
                      (click)="view(currentUrl, val.id)"
                    ></button>
                  </div>

                  <div *ngIf="type == 'view-row'">
                    <span (click)="row($event, 'sub-' + i)">
                      Ver mais
                      <span class="icn-arrow-right"></span>
                    </span>
                  </div>

                  <div *ngIf="type == 'edit'">
                    <button
                      class="icn-edit"
                      (click)="edit(currentUrl, val.id)"
                    ></button>
                  </div>

                  <div *ngIf="type == 'delete'">
                    <button
                      class="icn-delete"
                      (click)="delete(val.endpoints.delete, val.id)"
                    ></button>
                  </div>

                  <div *ngIf="type == 'approved'">
                    <button
                      class="icn-check"
                      (click)="approved(val.endpoints.approved, val.id)"
                    ></button>
                  </div>

                  <div *ngIf="type == 'disapproved'">
                    <button
                      class="icn-close"
                      (click)="disapproved(val.endpoints.disapproved, val.id)"
                    ></button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
        </tr>
        <tr
          *ngIf="arr.data[arr.data.length - 1].row"
          class="sub-row sub-{{ i }}"
        >
          <td [attr.colspan]="arr.data.length" class="no-pad">
            <table width="100%">
              <thead>
                <tr>
                  <th
                    *ngFor="let val of arr.data[arr.data.length - 1].row.thead"
                  >
                    <div *ngIf="val != 'AÇÕES'">{{ val }}</div>
                    <div *ngIf="val == 'AÇÕES'" class="text-align-center">
                      {{ val }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    *ngFor="
                      let val of arr.data[arr.data.length - 1].row.tbody.data
                    "
                  >
                    <div *ngIf="!val?.actions">
                      {{ val }}
                      <div>{{ val | currencyFormat: "pt-BR" }}</div>
                    </div>

                    <div class="text-align-center" *ngIf="val?.actions">
                      <div class="btn" *ngFor="let type of val.actions">
                        <div *ngIf="type == 'view'">
                          <button
                            class="icn-view"
                            (click)="view(currentUrl, val.id)"
                          ></button>
                        </div>

                        <div *ngIf="type == 'view-row'">
                          <button
                            class="icn-arrow-right"
                            (click)="viewRow()"
                          ></button>
                        </div>

                        <div *ngIf="type == 'edit'">
                          <button
                            class="icn-edit"
                            (click)="edit(currentUrl, val.id)"
                          ></button>
                        </div>

                        <div *ngIf="type == 'delete'">
                          <button
                            class="icn-delete"
                            (click)="delete(val.endpoints.delete, val.id)"
                          ></button>
                        </div>

                        <div *ngIf="type == 'approved'">
                          <button
                            class="icn-check"
                            (click)="approved(val.endpoints.approved, val.id)"
                          ></button>
                        </div>

                        <div *ngIf="type == 'disapproved'">
                          <button
                            class="icn-close"
                            (click)="
                              disapproved(val.endpoints.disapproved, val.id)
                            "
                          ></button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>

<div id="list" class="no-result" *ngIf="dataList.total == 0">
  <h1>Sua pesquisa não retornou resultados.</h1>
</div>
